import React from 'react';
import __ from "../../../i18n";
import InlineEditor from "../inline-editor/InlineEditor";
import DocumentHelper from "../../../helpers/DocumentHelper";
import Icon from "../../../../bootstrap/components/icon/Icon";


function getColumnConfigs({updateItem, refreshData}) {
    return [
        {
            key: 'id',
            name: __('ID'),
            sortable: true
        },
        {
            key: 'title',
            name: __('Title'),
            sortable: true,
            renderValue: (value, item) => {
                return <div className="title-view">
                    <span>{value}</span>
                    <a href={DocumentHelper.getUrl(item)} target="_blank">
                        <Icon name="external-link"/>
                    </a>
                </div>;
            },
            renderEditor: (item, onSubmittingChange, close) => {
                return <InlineEditor
                    item={item}
                    updateItem={updateItem}
                    close={close}
                />;
            }
        },
        {
            key: 'mime_type',
            name: __('Mime type'),
            sortable: true
        },
        {
            key: 'extension',
            name: __('Extension'),
            sortable: true
        },
    ];
}

export default {
    getColumnConfigs
};
